// extracted by mini-css-extract-plugin
module.exports = {"page":"Gift_page__jv6g-","content":"Gift_content__1oV8x","deletedPrice":"Gift_deletedPrice__qamof"};